export const BUILD_COMPLETE_ACTIVITY_CODE = 'BLDC' as const;
